import Aura from "@primeuix/themes/aura";
import { nl } from "primelocale/js/nl.js";
import { Plugin } from "vue";

import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ToastService from "primevue/toastservice";
import Tooltip from "primevue/tooltip";

export const vueUiPlugin: Plugin = {
  install(app, _options) {
    app.use(PrimeVue, {
      locale: nl,
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false,
        },
      },
    });

    app.directive("tooltip", Tooltip);

    app.use(ConfirmationService);
    app.use(ToastService);
  },
};
